import React, { useState } from 'react';
import { Card, Button, Grid, GridItem } from '@chakra-ui/react'; // Import Chakra UI components
import { BASE_URL } from '../../Globalapi/Globalapi';

const SchoolCreate = () => {
  // Define state to hold form data
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    s_name: '',
    s_address: '',
    s_email: '',
    s_phone: '',
    place: '',
    latitude: '',
    longitude: ''
  });

  // Define a state to hold form submission status
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Handle change in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/school_registration.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setIsLoading(false);

      // Handle success or failure
      if (result.success) {
        setStatus('School registered successfully!');
      } else {
        setStatus(`Error: ${result.message}`);
      }
    } catch (error) {
      setIsLoading(false);
      setStatus('Error: Unable to register school');
    }
  };

  return (
    <Card w="100%" maxW="800px" margin="auto" p={5} boxShadow="lg" borderRadius="md">
      <div className="form-container">
        {/* Title: Centered with bottom margin */}
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Register School</h1>

        <form onSubmit={handleSubmit}>
          {/* Use Grid for form layout */}
          <Grid 
            templateColumns={{ base: '1fr', lg: '1fr 1fr' }} // 1 column on small screens, 2 columns on large screens
            gap={4} 
            w="100%"
          >
            {/* Username Input */}
            <GridItem>
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                placeholder="Enter your username"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* Password Input */}
            <GridItem>
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* School Name Input */}
            <GridItem>
              <label htmlFor="s_name">School Name</label>
              <input
                id="s_name"
                type="text"
                name="s_name"
                value={formData.s_name}
                onChange={handleChange}
                required
                placeholder="Enter school name"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* School Address Input */}
            <GridItem>
              <label htmlFor="s_address">School Address</label>
              <input
                id="s_address"
                type="text"
                name="s_address"
                value={formData.s_address}
                onChange={handleChange}
                required
                placeholder="Enter school address"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* School Email Input */}
            <GridItem>
              <label htmlFor="s_email">School Email</label>
              <input
                id="s_email"
                type="email"
                name="s_email"
                value={formData.s_email}
                onChange={handleChange}
                required
                placeholder="Enter school email"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* School Phone Input */}
            <GridItem>
              <label htmlFor="s_phone">School Phone</label>
              <input
                id="s_phone"
                type="tel"
                name="s_phone"
                value={formData.s_phone}
                onChange={handleChange}
                required
                placeholder="Enter school phone number"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* Place Input */}
            <GridItem>
              <label htmlFor="place">Place</label>
              <input
                id="place"
                type="text"
                name="place"
                value={formData.place}
                onChange={handleChange}
                required
                placeholder="Enter place"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* Latitude Input */}
            <GridItem>
              <label htmlFor="latitude">Latitude</label>
              <input
                id="latitude"
                type="number"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                required
                placeholder="Enter latitude"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* Longitude Input */}
            <GridItem>
              <label htmlFor="longitude">Longitude</label>
              <input
                id="longitude"
                type="number"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                required
                placeholder="Enter longitude"
                style={{ width: '100%' }}
              />
            </GridItem>

            {/* Submit Button */}
            <GridItem colSpan={2}>
              <Button
                type="submit"
                isLoading={isLoading}
                colorScheme="teal"  // Set the button color to teal
                width="100%"  // Make the button span the full width
                mt={4}  // Add some margin-top for spacing
              >
                {isLoading ? 'Registering...' : 'Register School'}
              </Button>
            </GridItem>
          </Grid>
        </form>

        {status && <p>{status}</p>}
      </div>
    </Card>
  );
};

export default SchoolCreate;
